export default __webpack_public_path__ + "static/media/030206202112102.76efca5e.png";